import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';



function accessListGetList(list_name) {
    console.log("FIRESTORE : accessListGetList : " + list_name);
    
    let res;
    return firebase.firestore()
        .collection('user_lists')
        .doc(list_name)     
        .get()
        .then(function ( doc ) {
            res = doc.data();
            console.log(doc.data());
            return res;
        })
        .catch(function (error) {
            console.error("   Failure : ", error);
            return undefined;

        });

}


function accessListUpdateEntry(list_name, email, entry) {
    console.log("FIRESTORE : updateUserAccount; email = " + email + " Acc List : " + list_name);
    let res;

    return firebase.firestore()
        .collection("user_lists")
        .doc(list_name)
        .collection("per_mail")
        .doc(email)
        .set(entry, { merge: true })
        .then(function () {
            console.log("   Success : Update fine for " + email);
            return 1;
        })
        .catch(function (error) {
            console.error("   Failure : ", error);
            return -1;
        });

}

// Check, if there is a  account fpr this e-mail
function accessListGetEntry(list_name, email) {
    console.log(".. AccessListGetEntry");
    
    let res = null;
    let data;
    return firebase.firestore()
        .collection('user_lists')
        .doc(list_name)
        .collection('per_mail')
        .doc(email)
        .get()
        .then(function (doc) {
            data = doc.data();

            if (data) {
                console.log("Zugriff ok und Eintrag gefunden");
                res = data;
            }
            else {
                console.error("   Zugriff ok, aber e-mail nicht in der Liste :" + email);
                res = undefined;
            }
            return res;
        })
        .catch(function (error) {
            // Kann, passieren, wenn wir einen anonymen user haben...
            // odee, dass wir offline sind.
            console.error("   Zugriffsfehler (das sollte nocht passieren) : ", error);
            return '';
        });

}


async function accessListGetNextListId(list_name) {

    console.log("ListName = " + list_name)
    var docRef = firebase.firestore()
        .collection('user_lists')
        .doc(list_name);

    let result;

    await firebase.firestore().runTransaction(async function (transaction) {

        let actual_list = null;
        console.log("   Reading current counter value for " + docRef);

        await transaction.get(docRef)
            .then(function (doc) {
                if (doc.exists) {
                    actual_list = doc.data();
                }
            });

        console.log(JSON.stringify(actual_list))

        // The data have not been found in firestore
        if (actual_list == null) {
            console.log("   Failed reading value.")
            return Promise.reject(-1);
        }


        var nextId = actual_list.next_id + 1;
        console.log("   Updating: " + nextId)
        await transaction
            .update(docRef, { next_id: nextId });


        nextId = nextId - 1

        let prefix = '';
        if (nextId < 10) {
            prefix = "00";
        } else
            if (nextId < 100) {
                prefix = "0";
            }

        let account = prefix + nextId;


        return account;

    })
        .then(function (account) {
            console.log("   Success : Account is " + account);
            result = account;
        })
        .catch(function (error) {
            console.error("   Failure : ", error);
            result = null;
        });

        return result;
}

export {  
    accessListGetList,
    accessListGetEntry,
    accessListGetNextListId,
    accessListUpdateEntry,
};